import { Box, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../CustomComponents/CustomButton";
import { CovReducerAction } from "../Store/Cov/CovReducer";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useRef } from "react";
import { useEffect } from "react";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export default function CovLoanDetailsScreenSelection(props) {
  const screenSelection = useSelector((state) => state.cov.screenSelection);

  const dispatch = useDispatch();

  //shortcut key
  const closeRef = useRef(null);
  const selectRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covLoanDetailSelection",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "q") {
        closeRef.current.click();
      } else if (charCode === "g") {
        selectRef.current.click();
      }
    }
  };

  const leftChecked = intersection(
    screenSelection.checked,
    screenSelection.left
  );
  const rightChecked = intersection(
    screenSelection.checked,
    screenSelection.right
  );

  const handleToggle = (value) => () => {
    const currentIndex = screenSelection.checked.indexOf(value);
    const newChecked = [...screenSelection.checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    dispatch(CovReducerAction.updateScreenSelectionchecked(newChecked));
  };

  const handleAllRight = () => {
    dispatch(
      CovReducerAction.updateScreenSelectionRight(
        screenSelection.right.concat(screenSelection.left)
      )
    );
    dispatch(CovReducerAction.updateScreenSelectionLeft([]));
  };

  const handleCheckedRight = () => {
    dispatch(
      CovReducerAction.updateScreenSelectionRight(
        screenSelection.right.concat(leftChecked)
      )
    );
    dispatch(
      CovReducerAction.updateScreenSelectionLeft(
        not(screenSelection.left, leftChecked)
      )
    );
    dispatch(
      CovReducerAction.updateScreenSelectionchecked(
        not(screenSelection.checked, leftChecked)
      )
    );
  };

  const handleCheckedLeft = () => {
    dispatch(
      CovReducerAction.updateScreenSelectionLeft(
        screenSelection.left.concat(rightChecked)
      )
    );
    dispatch(
      CovReducerAction.updateScreenSelectionRight(
        not(screenSelection.right, rightChecked)
      )
    );
    dispatch(
      CovReducerAction.updateScreenSelectionchecked(
        not(screenSelection.checked, rightChecked)
      )
    );
  };

  const handleAllLeft = () => {
    dispatch(
      CovReducerAction.updateScreenSelectionLeft(
        screenSelection.left.concat(screenSelection.right)
      )
    );
    dispatch(CovReducerAction.updateScreenSelectionRight([]));
  };

  const customList = (items, title) => (
    <Paper sx={{ width: 200, height: 350, overflow: "auto", border: "blue" }}>
      <h4 style={{ marginLeft: "1rem" }}>{title}</h4>
      <List dense component="div" role="list">
        {items.map((value) => {
          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={screenSelection.checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": value,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={value} primary={value} />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item>{customList(screenSelection.left, "List of Screens:")}</Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleAllRight}
              disabled={screenSelection.left.length === 0}
              aria-label="move all right"
            >
              ≫
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleAllLeft}
              disabled={screenSelection.right.length === 0}
              aria-label="move all left"
            >
              ≪
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          {customList(screenSelection.right, "Selected Screens:")}
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "14px",
        }}
        onClick={() => {
          dispatch(CovReducerAction.updateshowScreenSelection(false));
        }}
      >
        <Tooltip title="Ctrl+G" placement="top">
          <CustomButton
            sx={{ height: "2rem" }}
            variant="contained"
            onClick={() => {
              props.onSaveScreenSelectionClick();
            }}
            ref={selectRef}
            disabled={screenSelection.right.length === 0}
          >
            Apply
          </CustomButton>
        </Tooltip>
        <Tooltip title="Ctrl+Q" placement="top">
          <Button
            sx={{
              color: "white",
              backgroundColor: "black",
              height: "2rem",
              fontWeight: "bold",
              float: "right",
              marginLeft: "1%",
            }}
            onMouseOver={({ target }) => {
              target.style.backgroundColor = "black";
              target.style.color = "white";
            }}
            variant="contained"
            onClick={() => {
              dispatch(CovReducerAction.updateshowScreenSelection(false));
            }}
            ref={closeRef}
          >
            Close
          </Button>
        </Tooltip>
      </Box>
    </>
  );
}
